import { ReactComponent as Empty } from "../../../common/assets/icons/empty.svg";

export default function ErrorPage() {
    return (
        <div className="flex-1 h-full flex flex-col gap-5 text-lg text-grayicon items-center justify-center">
            <Empty />
            <p>죄송합니다. 페이지를 찾을 수 없습니다.</p>
        </div>
    );
}
